'use strict';

module.exports = {
  button: {
    button: {
      base: 'bg-primary',
    },
    primary: {
      base: 'text-white bg-primary border border-transparent',
    },
    outline: {
      base: 'text-black bg-white border border-in-transit-2',
    },
  },
  tableContainer: {
    base: 'w-table overflow-hidden rounded-lg ring-1 ring-black ring-opacity-5',
  },
  select: {
    base: 'block py-2 text-sm dark:text-gray-300 focus:outline-none rounded-md',
  },
};
